import { Company } from '../model/entities';
import { proxyApiAxios } from './CustomAxios';
import providerAuthService from '../services/ProviderAuthService';

class CompanyApi {
    list = async (hubId: string): Promise<Company[]> => {
        const headers = await providerAuthService.getRequestHeader('ACC');
        const response = await proxyApiAxios.get<Company[]>('/companies', {
            params: { hubId },
            headers
        });
        return response.data;
    };
}

const companyApi: CompanyApi = new CompanyApi();
export default companyApi;
